import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a1400] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🎸 ¿Qué agrega el{' '}
            <span className="text-[#FFD700]" data-id="element-78">Arsenal Visual Premium™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            Vos ya tenés las clases (MegaPack). El Arsenal le da el impacto
            visual que hace que el alumno diga "wow" y que los padres piensen
            "esto es una academia seria".
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0a00] border-b border-[#FFD700]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#FFD700]/30" data-id="element-83">
              Sin Arsenal
            </div>
            <div className="p-4 font-bold text-[#FFD700] text-center border-l border-[#FFD700]/30" data-id="element-84">
              Con Arsenal
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              El alumno necesita ver un patrón escrito
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Arsenal:
              </span>
              Dibujás algo desprolijo en el cuaderno
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-91">
                Con Arsenal:
              </span>
              Deslizás la Flashcard #18 en la tablet. 10 segundos.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Querés practicar con música real
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Arsenal:
              </span>
              Buscás 10 minutos en YouTube durante la clase
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-98">
                Con Arsenal:
              </span>
              Abrís el Atlas, clickeás el link. El alumno toca con una banda.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              Un padre viene a ver el estudio
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Arsenal:
              </span>
              Ve una habitación con cuadernos y fotocopias
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-105">
                Con Arsenal:
              </span>
              Ve los 5 Pósters Studio Pro en la pared. Piensa: "esto es
              profesional."
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              El alumno pregunta "¿puedo aprender ese tema?"
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Arsenal:
              </span>
              Buscás la partitura por internet
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-112">
                Con Arsenal:
              </span>
              Abrís los Grooves de Oro. La transcripción ya está.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-113">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-115">
                Situación:
              </span>
              Querés proponer un juego para hacer más dinámica la clase
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-116">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-117">
                Sin Arsenal:
              </span>
              Improvisás algo
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-118">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-119">
                Con Arsenal:
              </span>
              Sacás las Flashcards, las cortás y hacés el juego de cartas
              rítmicas.
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-120">
          ✅ EL ARSENAL VISUAL PREMIUM™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-121">
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-122">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-123">
              30 Flashcards Rítmicas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-124">
              Patrones visuales a página completa, listos para mostrar en tablet
              o imprimir. 10 de nivel Inicial, 10 Intermedio, 10 Avanzado. Nunca
              más dibujos a mano.
            </p>
          </div>
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-125">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-126">
              Atlas de Repertorio: 150 Canciones Categorizadas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-127">
              Rock, Funk, Blues, Jazz, Metal, Pop argentino. Con links directos
              a versiones sin batería en YouTube. Filtradas por nivel, estilo y
              habilidad técnica.
            </p>
          </div>
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-128">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-129">
              Colección Studio Pro: 5 Pósters en Alta Resolución
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-130">
              Mapa de los 40 Rudimentos · Pirámide de Subdivisiones · Anatomía
              de la Batería · Termómetro de Dinámicas · Guía de Ergonomía y
              Postura. Listos para imprimir en A3 o A2.
            </p>
          </div>
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-131">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-132">
              Los 8 Grooves de Oro
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-133">
              Billie Jean, Back in Black, Smells Like Teen Spirit, Superstition,
              Rosanna, Come Together, Sunday Bloody Sunday, De Música Ligera.
              Transcriptos y analizados pedagógicamente para enseñar en clase.
            </p>
          </div>
        </div>
      </div>
    </section>;
}